import React from 'react';
import { InputNumber } from 'antd';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

export default class ThicknessEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChangeTop(e) {
        this.props.source.value.top = e;
        this.setState({});
    }

    onChangeRight(e) {
        this.props.source.value.right = e;
        this.setState({});
    }

    onChangeBottom(e) {
        this.props.source.value.bottom = e;
        this.setState({});
    }

    onChangeLeft(e) {
        this.props.source.value.left = e;
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    render() {

        return (
            <div className="layout-h center">
                <InputNumber
                    className="fill"
                    style={{ borderRadius: '2px 0px 0px 2px' }}
                    value={this.props.source.value.top}
                    min={this.props.source.minValue === undefined ? Number.MIN_SAFE_INTEGER : this.props.source.minValue}
                    max={this.props.source.maxValue === undefined ? Number.MAX_SAFE_INTEGER : this.props.source.maxValue}
                    onChange={e => this.onChangeTop(e)} />
                <InputNumber
                    className="fill"
                    style={{ marginLeft: -1, borderRadius: 0 }}
                    value={this.props.source.value.right}
                    min={this.props.source.minValue === undefined ? Number.MIN_SAFE_INTEGER : this.props.source.minValue}
                    max={this.props.source.maxValue === undefined ? Number.MAX_SAFE_INTEGER : this.props.source.maxValue}
                    onChange={e => this.onChangeRight(e)} />
                <InputNumber
                    className="fill"
                    style={{ marginLeft: -1, borderRadius: 0 }}
                    value={this.props.source.value.bottom}
                    min={this.props.source.minValue === undefined ? Number.MIN_SAFE_INTEGER : this.props.source.minValue}
                    max={this.props.source.maxValue === undefined ? Number.MAX_SAFE_INTEGER : this.props.source.maxValue}
                    onChange={e => this.onChangeBottom(e)} />
                <InputNumber
                    className="fill"
                    style={{ marginLeft: -1, borderRadius: '0 2px 2px 0' }}
                    value={this.props.source.value.left}
                    min={this.props.source.minValue === undefined ? Number.MIN_SAFE_INTEGER : this.props.source.minValue}
                    max={this.props.source.maxValue === undefined ? Number.MAX_SAFE_INTEGER : this.props.source.maxValue}
                    onChange={e => this.onChangeLeft(e)} />
            </div>
        );
    }
}

PropertyGridUtils.register("thickness", (source, propertyGrid) => <ThicknessEditor source={source} propertyGrid={propertyGrid} />);